export default {
  name: 'informations_manual_domiciliation_bank_account_owner_name',
  component_path: 'modules/procedures/blocks/BlockInputText',
  static_mandatory: ['required']
}